import { Button } from '@design/components/button/Button';
import React, { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { RenameInput } from '../rename-input/RenameInput';
import { WatchlistManagerHeaderProps } from '../watchlist-manager-header/WatchlistManagerHeader';
import styles from './WatchlistManagerName.module.scss';

export interface WatchlistManagerNameProps extends WatchlistManagerHeaderProps {
  openNameInput: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const WatchlistManagerName = ({
  isRenameActive,
  listName,
  onUpdateName,
  openNameInput,
  setIsRenameActive,
  hasEntities,
  hasInputError,
  activeListName,
}: WatchlistManagerNameProps) => {
  const { t } = useTranslation('watchlistManager');

  if (activeListName) {
    return (
      <h4 className={styles.title} data-testid="watchlist-title">
        {t('watchlistManager:addAssetsToWatchlist', {
          name: activeListName,
        })}
      </h4>
    );
  }

  if (!hasEntities) {
    return (
      <h4 className={styles.title} data-testid="watchlist-title">
        {t('watchlistManager:createNewWatchlist')}
      </h4>
    );
  }

  return (
    <div className={styles.watchlistManagerTitleContainer}>
      {isRenameActive ? (
        <RenameInput
          value={listName}
          setValue={onUpdateName}
          setIsRenameActive={setIsRenameActive}
          hasError={hasInputError}
        />
      ) : (
        <>
          <h4 className={styles.title} data-testid="watchlist-title">
            {listName || t('watchlistManager:nameYourWatchlist')}
          </h4>
          <Button
            className={styles.styledButton}
            iconName="Pencil"
            variant="empty"
            size="small"
            onClick={openNameInput}
            data-testid="pencil-button"
          />
        </>
      )}
    </div>
  );
};
